export default __webpack_public_path__ + "static/media/login-bg.36c83385.gif";